<script>
import ContentsWithLinks from "@/components/article/politiken/ContentsWithLinks.vue";
export default {
  name: "ArticleContentMeaning",
  components: { ContentsWithLinks },
  props: {
    meaning: {
      type: Object,
      required: true
    }
  }
};
</script>

<template>
  <div>
    <div class="indentation-container">
      <span
        v-if="meaning.meaningNumber"
        class="article-list-bullet article-list-bullet--primary article-list-bullet--prominent"
      >
        {{ meaning.meaningNumber }}.
      </span>
    </div>
    <div class="indentation-container">
      <div :class="{ 'article-content__politiken-grid': meaning.subLemma }">
        <span
          v-if="meaning.subLemma"
          class="article-content__text article-content__text--primary article-content__text--prominent article-content__politiken-grid-label"
          >{{ meaning.subLemma }}</span
        >
        <span
          class="article-content__text"
          :class="
            meaning.subLemma
              ? 'article-content__politiken-grid-content'
              : 'article-content__text--primary article-content__text--prominent'
          "
        >
          <template v-if="meaning.comment">(<span v-html="meaning.comment"></span>)&nbsp;</template>
          <span v-html="meaning.definition"></span>
        </span>
      </div>
      <div v-if="meaning.example.length > 0" class="article-content__politiken-grid">
        <span class="article-content__text article-content__politiken-grid-label"
          >{{ $t("article.polSchoolDada.examples") }}:</span
        >
        <div class="article-content__politiken-grid-content">
          <span v-for="(meaningContent, meaningIndex) in meaning.example" :key="meaningIndex">
            <span v-if="meaningIndex > 0" class="article-content__text--secondary-light">
              &#183;
            </span>
            <ContentsWithLinks
              :key="meaningIndex"
              :content="meaningContent"
              text-class="article-content__text article-content__text--secondary-light article-content__text--italic"
            ></ContentsWithLinks>
          </span>
        </div>
      </div>
    </div>
    <div class="article-content__spacer"></div>
  </div>
</template>
